module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/co-4c87d079860a09479706816fb964cfdc.svg";